import ListingsRoutingResolver from './ListingRoutingResolver';

class ClientsListingResolver extends ListingsRoutingResolver {

    constructor() {
        super()
        this.key = "client"
    }
}

export default ClientsListingResolver
